import { render, staticRenderFns } from "./tarjeta-giratoria.vue?vue&type=template&id=0cf9ff73&scoped=true&"
import script from "./tarjeta-giratoria.vue?vue&type=script&lang=js&"
export * from "./tarjeta-giratoria.vue?vue&type=script&lang=js&"
import style0 from "./tarjeta-giratoria.vue?vue&type=style&index=0&id=0cf9ff73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf9ff73",
  null
  
)

export default component.exports